import API from './API.ts'

export default {
  //
  // GET
  //
  fetchCards () {
    return API.httpClient.get('camptrac/active-cards')
  },

  //
  // POST
  //
  addCard ({ bookingId, cardUid }) {
    return API.httpClient.post('camptrac/add-card', {
      booking_id: bookingId,
      card_uid: cardUid
    })
  },
  removeCard ({ bookingId, cardUid }) {
    return API.httpClient.post('camptrac/remove-card', {
      booking_id: bookingId,
      card_uid: cardUid
    })
  }
}
